// extracted by mini-css-extract-plugin
export default {"loading__container":"styles_loading__container__hztHx","loading__text--description":"styles_loading__text--description__jOYKb"};